import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Footer from '../../Footer'
import { AppState } from '../../../reducers'
import { setUIForwardAction } from '../../../actions'
import { UI } from '../../../constants/ui'
import './error.less'
import FooterMobile from '../../FooterMobile'
import { getMode } from '../../../hooks/mode'
import { MODE } from '../../../constants/mode'

const ERROR_TIMEOUT = 5000
const ERROR_TIMEOUT_WITH_BUTTON = 15000

const mapStateToProps = (state: AppState) => ({
  errorMessage: state.ui.error,
  errorTitle: state.ui.errorTitle,
  showButton: state.ui.showButton,
})
const mapDispatchToProps = { setUI: setUIForwardAction }

type DispatchProps = typeof mapDispatchToProps
type StateProps = ReturnType<typeof mapStateToProps>
type Props = DispatchProps & StateProps

const Component: React.FC<Props> = ({ errorTitle, errorMessage, setUI, showButton }: Props) => {
  const { t } = useTranslation()
  const mode = getMode()

  useEffect(() => {
    const timer = setTimeout(() => setUI(UI.MAIN), showButton ? ERROR_TIMEOUT_WITH_BUTTON : ERROR_TIMEOUT)
    return () => clearTimeout(timer)
  }, [setUI, showButton])

  if (mode === MODE.MOBILE) {
    return (
        <div className="error-component-mobile">
        <div className="error-component-mobile-wrapper">
          <div className="title" dangerouslySetInnerHTML={{ __html: t(errorTitle, { defaultValue: t('defaultErrorMessage') }) }}></div>
          <div className="message" dangerouslySetInnerHTML={{ __html: t(errorMessage, { defaultValue: t('turnToCheckInCounter') }) }}></div>
          {showButton && (
            <div className="button">
              <button className="main-button-mobile" onClick={() => setUI(UI.MAIN)}>
                {t('ok')}
              </button>
            </div>
          )}
        </div>
        <div className="footer-mobile-container">
          <FooterMobile />
        </div>
        </div>
    )
  }

  return (
    <>
      <div className="error-component">
        <div className="title">{t(errorTitle, { defaultValue: t('defaultErrorMessage') })}</div>
        <div className="message">{t(errorMessage, { defaultValue: t('turnToCheckInCounter') })}</div>
        {showButton && (
          <div className="button">
            <button className="main-button next" onClick={() => setUI(UI.MAIN)}>
              {t('ok')}
            </button>
          </div>
        )}
      </div>
      <Footer />
    </>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
